import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import ChangePassword from '../sections/auth/ChangePassword';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
        // {
        //   path: '/register',
        //   element: <RegisterPage />
        // },
        {
          path: '/change-password',
          element: <ChangePassword/>
        }
      ]
    }
  ]
};

export default LoginRoutes;
